export default function polarToSpecialCartesian(radius, angle) {
  return {
    x: radius * Math.cos(angle - Math.PI / 2),
    y: radius * Math.sin(angle - Math.PI / 2)
  };
}
